export default __webpack_public_path__ + "static/media/piratenxhumanisten_quer_hell.f1f4118c.svg";